<script context="module" lang="ts">
  import { iconRegistry } from "./registry";
  export const directions = ["n", "ne", "e", "se", "s", "sw", "w", "nw"] as const;
  export type IconName = keyof typeof iconRegistry;
  export type Direction = (typeof directions)[number];
</script>

<script lang="ts">
  import { isBasePathIcon, hasPathProps } from "./registry";

  export let name: IconName;
  export let direction: Direction = "n";
  export let animateRotation: boolean = false;

  $: iconDetails = iconRegistry[name];
  $: viewBox = iconDetails.viewBox;
  $: rotation = directions.indexOf(direction) * 45;
</script>

<svg
  {viewBox}
  fill-rule="evenodd"
  clip-rule="evenodd"
  style:transform={`rotate(${rotation}deg)`}
  class:animate={animateRotation}
>
  {#if hasPathProps(iconDetails)}
    {#each iconDetails.paths as path}
      <path d={path} {...iconDetails.pathProps} />
    {/each}
  {:else if isBasePathIcon(iconDetails)}
    {#each iconDetails.paths as path}
      <path d={path} />
    {/each}
  {:else}
    {#each iconDetails.shapes as shape}
      <svelte:element this={shape.elementType} {...shape.props} />
    {/each}
  {/if}
</svg>

<style>
  svg {
    width: var(--w, 1em);
    height: var(--h, 1em);
    fill: var(--color, currentColor);
    stroke: var(--stroke, none);
    overflow: visible;
    display: var(--display, block);
  }

  .animate {
    transition: transform 0.3s ease-out;
  }
</style>
